module.exports = __webpack_public_path__ + "img/social-dz.59e8d50b.svg";